let lang = 'en';

export type Links = {
  mobile: string;
  desktop: string;
};
export const NEW_INTRO_LINK = 'https://www.wix.com/new/intro';

export function setLang(newLang: string) {
  lang = newLang;
}

export function getStarted(isAnonymous?: boolean | undefined): Links {
  const defaultSigninLink = {
    postLogin: encodeURIComponent('https://www.wix.com/my-account/sites/'),
    postSignup: encodeURIComponent('https://www.wix.com/new/vertical?referralAdditionalInfo=HOMEPAGE'),
    postSignupIntro: encodeURIComponent(NEW_INTRO_LINK)
  };

  const mobile = 'https://users.wix.com/signin?referralInfo=TABLET&overrideLocale=' + lang;
  const desktop = isAnonymous ?
    NEW_INTRO_LINK :
    `https://users.wix.com/signin?overrideLocale=${lang}&referralInfo=HOMEPAGE&postLogin=${defaultSigninLink.postLogin}&postSignUp=${defaultSigninLink.postSignupIntro}`;

  return {
    mobile,
    desktop
  };
}

export function learnMore(): string {
  const howToLinks = {
    en: 'https://www.wix.com/how-to/make-a-website',
    es: 'https://es.wix.com/como-crear/una-pagina-web',
    it: 'https://it.wix.com/come-creare/un-sito-web',
    fr: 'https://fr.wix.com/comment-creer/un-site'
  };
  const link = howToLinks[lang];
  return link;
}

export function features(): string {
  const prefix = lang === 'en' ? 'www' : lang;
  return `https://${prefix}.wix.com/features/main`;
}
